
export enum CurrentAgentCommissionDialog {
    None = 'None',
    ChangeSchoolOverride = 'ChangeSchoolOverride'
}
